export const USER_COL_WIDTH = 195;
export const DATE_COL_WIDTH = 150;
